import classNames from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SocialField(_ref) {
  var {
    children,
    className,
    href,
    Icon
  } = _ref;
  return /*#__PURE__*/_jsx("li", {
    className: classNames('prezly-slate-social-field', className),
    title: children,
    children: /*#__PURE__*/_jsxs("a", {
      className: "prezly-slate-social-field__link",
      href: href,
      rel: "noreferrer noopener",
      target: "_blank",
      children: [Icon && /*#__PURE__*/_jsx(Icon, {
        "aria-hidden": "true",
        className: "prezly-slate-social-field__icon"
      }), children && /*#__PURE__*/_jsx("span", {
        className: "prezly-slate-social-field__value",
        children: children
      })]
    })
  });
}